import type * as Blockly from 'blockly/core';
import {
    expr,
    registerHelperFunction,
    registerSetupCode,
    resolveAnalogPin,
} from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const HELPER_CODE = `int _sbeGetFader(int pinNumber, int res, int minVal, int maxVal) {
  return map(analogRead(pinNumber), 0, res, minVal, maxVal);
}`;

export function register(gen: any): void {
    gen.forBlock['fader'] = function (block: Blockly.Block): [string, number] {
        const { pin, config } = resolveAnalogPin(block);
        const minVal = gen.valueToCode(block, 'MIN_VALUE', 0) || '0';
        const maxVal = gen.valueToCode(block, 'MAX_VALUE', 0) || '100';

        registerHelperFunction('fader', HELPER_CODE);
        registerSetupCode(pin, `  pinMode(${pin}, INPUT);\n`);

        return expr(`_sbeGetFader(${pin}, ${config.analogRes}, ${minVal}, ${maxVal})`);
    };
}
